import React, { useEffect, useState } from "react" 
import { useRenderStyling } from 'lib/hooks/useRenderStyling';
import { formatter, getApiFeedData, parseContent, parseContentGroup } from "../utils"
import { useRulesChecker } from "lib/hooks"
import { TrxDetailBlock, TrxDetailHeader, TrxDetailDataElement } from "."

export default function DetailScreenTrxInfo({ screen, renderPkg }:{ screen:any; renderPkg?:any }) {
  
  const [ rulesPackage, setRulesPackage ] = useState<any[]|null>(null)
  const [ currentElement, setCurrentElement ] = useState<any>(null)
  const [ contentToRender, setContentToRender ] = useState<any[]>([])

  const splitBlocksStyle = useRenderStyling("w-6/12 flex flex-col pl-4 pr-4 pt-0 pb-0", "styleObj")
  const blocksWrapperStyle = useRenderStyling("w-full flex gap-5", "styleObj")


  useEffect(() => {
    if( !currentElement ) {
      const elem = renderPkg.elements.find( (elem:any) => elem.refstr === "detail_screens" )
      if( elem ) setCurrentElement(elem)
    }
  },[renderPkg, currentElement])
  
  // if( !currentElement || !contentToRender?.length ) return <></>
  return (
    <TrxDetailBlock>
      <TrxDetailHeader title="Transaction Information" />
      <div {...blocksWrapperStyle}>
        {/* left side  */}
        <div {...splitBlocksStyle}>
          <TrxDetailDataElement id="merchant_name" label="Merchant" value={screen.trxinfo.merchant} />
          <TrxDetailDataElement label="Transaction ID" value={screen.trxinfo.trxId} />
          <TrxDetailDataElement label="Entry Method" value={screen.trxinfo.entryMethod} />
          <TrxDetailDataElement label="Response Code" value={screen.trxinfo.respCode} />
        </div>
        {/* right side  */}
        <div {...splitBlocksStyle}>
          <TrxDetailDataElement label="Date" value={ formatter.date(screen.trxinfo.date, "MMM DD, YYYY") } />
          <TrxDetailDataElement label="Transaction Type" value={screen.trxinfo.trxType} />
          <TrxDetailDataElement label="Transaction Amount" value={ formatter.currency(screen.trxinfo.trxAmount, screen.trxinfo.trxCurrency) } />
          <TrxDetailDataElement label="Status" value={screen.trxinfo.status} />
        </div>
      </div>
    </TrxDetailBlock>
  )
}